/**
 * Extract the next page cursor for use with useInfiniteQuery's getNextPageParam.
 * Returns undefined (not null) when there are no more pages, which signals
 * React Query to stop fetching.
 */
export function getNextPageParam(lastPage) {
    return lastPage.nextCursor ?? undefined;
}
/**
 * Flatten an array of paginated pages into a single array of items.
 * Useful in useInfiniteQuery select or when rendering results.
 */
export function flattenPages(pages) {
    return pages.flatMap((page) => page.data);
}
/**
 * Default page size for a browsable list in a web app.
 *
 * Deliberately NOT the server-side default. `PaginationQuerySchema` prefaults to
 * 10 and that stays where it is, because the same routes are the chat agent's MCP
 * tool surface (see chat.toolsets.ts): every list result the agent pulls in lands
 * in its context and is paid for per token, so a bigger default would cost real
 * money for no UI benefit. A human scanning a table wants a screenful; the agent
 * wants the smallest set that answers the question and can ask for more via
 * `limit`. Those are different numbers, so the UI states its own explicitly.
 *
 * 25 rather than 50: the list endpoints batch their companion loads into a fixed
 * number of IN queries per page, so page size costs almost nothing in DB round
 * trips, but it does multiply response size - and the stored-emails row carries a
 * full untruncated body. 25 is a real improvement over 10 and is safe on every
 * surface; going further should follow a payload measurement on emails.
 *
 * Surfaces with their own reason for a different number (a picker showing 20, the
 * bank-statement tables at 50) keep it - this is the default, not a ceiling.
 */
export const DEFAULT_LIST_PAGE_SIZE = 25;
